



























































import { defineComponent, PropType } from '@vue/composition-api'
import { categoryList, clientType, userType } from '@/constants/app-detail'
import { AppQueryModel } from '@/types/models/app'

export default defineComponent({
  name: 'AppSearch',
  props: {
    filterData: {
      type: Object as PropType<AppQueryModel>,
      require: true
    }
  },
  emits: ['change-list'],
  setup(props, { emit }) {
    const filterObj: any = props.filterData
    const handleSearch = () => {
      emit('change-list')
    }
    const handleClick = (tab: string, value: number) => {
      if (value === filterObj[tab]) return
      filterObj[tab] = value
      emit('change-list')
    }

    return {
      filterObj,
      handleSearch,
      handleClick,
      categoryList,
      clientType,
      userType
    }
  }
})
